"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _get2 = _interopRequireDefault(require("lodash/get"));
var _isNil2 = _interopRequireDefault(require("lodash/isNil"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var PositiveIssueTagOne = 'IssuePositiveOne';
var PositiveIssueTagTwo = 'IssuePositiveTwo';
var PositiveIssueTagThree = 'IssuePositiveThree';
var PositiveIssueTagFour = 'IssuePositiveFour';
var PositiveIssueTagFive = 'IssuePositiveFive';
var PositiveIssueTagSix = 'IssuePositiveSix';
var PositiveIssueTagSeven = 'IssuePositiveSeven';
var PositiveIssueTagEight = 'IssuePositiveEight';
var PositiveIssueTagNine = 'IssuePositiveNine';
var PositiveIssueTagTen = 'IssuePositiveTen';
var PositiveIssueTagEleven = 'IssuePositiveEleven';
var PositiveIssueTagTwelve = 'IssuePositiveTwelve';
var PositiveIssueTagThirteen = 'IssuePositiveThirteen';
var PositiveIssueTagFourteen = 'IssuePositiveFourteen';
var PositiveIssueTagFifteen = 'IssuePositiveFifteen';
var NegativeIssueTagOne = 'IssueNegativeOne';
var NegativeIssueTagTwo = 'IssueNegativeTwo';
var NegativeIssueTagThree = 'IssueNegativeThree';
var NegativeIssueTagFour = 'IssueNegativeFour';
var NegativeIssueTagFive = 'IssueNegativeFive';
var NegativeIssueTagSix = 'IssueNegativeSix';
var NegativeIssueTagSeven = 'IssueNegativeSeven';
var NegativeIssueTagEight = 'IssueNegativeEight';
var NegativeIssueTagNine = 'IssueNegativeNine';
var NegativeIssueTagTen = 'IssueNegativeTen';
var NegativeIssueTagEleven = 'IssueNegativeEleven';
var NegativeIssueTagTwelve = 'IssueNegativeTwelve';
var NegativeIssueTagThirteen = 'IssueNegativeThirteen';
var NegativeIssueTagFourteen = 'IssueNegativeFourteen';
var NegativeIssueTagFifteen = 'IssueNegativeFifteen';
var _default = exports["default"] = function _default(_ref) {
  var response = _ref.response,
    initialValueSettings = _ref.initialValueSettings;
  var initialValues = {};
  var base = (0, _get2["default"])(response, initialValueSettings.basePath);
  initialValues.negative = {
    userRows: []
  };
  initialValues.positive = {
    userRows: []
  };

  // ================= NEGATIVE ================= //

  if (!(0, _isNil2["default"])(base.InitialValues.devTags[NegativeIssueTagOne])) {
    initialValues.negative.userRows.push({
      columns: [base.InitialValues.devTags[NegativeIssueTagOne]]
    });
  }
  if (!(0, _isNil2["default"])(base.InitialValues.devTags[NegativeIssueTagTwo])) {
    initialValues.negative.userRows.push({
      columns: [base.InitialValues.devTags[NegativeIssueTagTwo]]
    });
  }
  if (!(0, _isNil2["default"])(base.InitialValues.devTags[NegativeIssueTagThree])) {
    initialValues.negative.userRows.push({
      columns: [base.InitialValues.devTags[NegativeIssueTagThree]]
    });
  }
  if (!(0, _isNil2["default"])(base.InitialValues.devTags[NegativeIssueTagFour])) {
    initialValues.negative.userRows.push({
      columns: [base.InitialValues.devTags[NegativeIssueTagFour]]
    });
  }
  if (!(0, _isNil2["default"])(base.InitialValues.devTags[NegativeIssueTagFive])) {
    initialValues.negative.userRows.push({
      columns: [base.InitialValues.devTags[NegativeIssueTagFive]]
    });
  }
  if (!(0, _isNil2["default"])(base.InitialValues.devTags[NegativeIssueTagSix])) {
    initialValues.negative.userRows.push({
      columns: [base.InitialValues.devTags[NegativeIssueTagSix]]
    });
  }
  if (!(0, _isNil2["default"])(base.InitialValues.devTags[NegativeIssueTagSeven])) {
    initialValues.negative.userRows.push({
      columns: [base.InitialValues.devTags[NegativeIssueTagSeven]]
    });
  }
  if (!(0, _isNil2["default"])(base.InitialValues.devTags[NegativeIssueTagEight])) {
    initialValues.negative.userRows.push({
      columns: [base.InitialValues.devTags[NegativeIssueTagEight]]
    });
  }
  if (!(0, _isNil2["default"])(base.InitialValues.devTags[NegativeIssueTagNine])) {
    initialValues.negative.userRows.push({
      columns: [base.InitialValues.devTags[NegativeIssueTagNine]]
    });
  }
  if (!(0, _isNil2["default"])(base.InitialValues.devTags[NegativeIssueTagTen])) {
    initialValues.negative.userRows.push({
      columns: [base.InitialValues.devTags[NegativeIssueTagTen]]
    });
  }
  if (!(0, _isNil2["default"])(base.InitialValues.devTags[NegativeIssueTagEleven])) {
    initialValues.negative.userRows.push({
      columns: [base.InitialValues.devTags[NegativeIssueTagEleven]]
    });
  }
  if (!(0, _isNil2["default"])(base.InitialValues.devTags[NegativeIssueTagTwelve])) {
    initialValues.negative.userRows.push({
      columns: [base.InitialValues.devTags[NegativeIssueTagTwelve]]
    });
  }
  if (!(0, _isNil2["default"])(base.InitialValues.devTags[NegativeIssueTagThirteen])) {
    initialValues.negative.userRows.push({
      columns: [base.InitialValues.devTags[NegativeIssueTagThirteen]]
    });
  }
  if (!(0, _isNil2["default"])(base.InitialValues.devTags[NegativeIssueTagFourteen])) {
    initialValues.negative.userRows.push({
      columns: [base.InitialValues.devTags[NegativeIssueTagFourteen]]
    });
  }
  if (!(0, _isNil2["default"])(base.InitialValues.devTags[NegativeIssueTagFifteen])) {
    initialValues.negative.userRows.push({
      columns: [base.InitialValues.devTags[NegativeIssueTagFifteen]]
    });
  }

  // ================= POSITIVE ================= //

  if (!(0, _isNil2["default"])(base.InitialValues.devTags[PositiveIssueTagOne])) {
    initialValues.positive.userRows.push({
      columns: [base.InitialValues.devTags[PositiveIssueTagOne]]
    });
  }
  if (!(0, _isNil2["default"])(base.InitialValues.devTags[PositiveIssueTagTwo])) {
    initialValues.positive.userRows.push({
      columns: [base.InitialValues.devTags[PositiveIssueTagTwo]]
    });
  }
  if (!(0, _isNil2["default"])(base.InitialValues.devTags[PositiveIssueTagThree])) {
    initialValues.positive.userRows.push({
      columns: [base.InitialValues.devTags[PositiveIssueTagThree]]
    });
  }
  if (!(0, _isNil2["default"])(base.InitialValues.devTags[PositiveIssueTagFour])) {
    initialValues.positive.userRows.push({
      columns: [base.InitialValues.devTags[PositiveIssueTagFour]]
    });
  }
  if (!(0, _isNil2["default"])(base.InitialValues.devTags[PositiveIssueTagFive])) {
    initialValues.positive.userRows.push({
      columns: [base.InitialValues.devTags[PositiveIssueTagFive]]
    });
  }
  if (!(0, _isNil2["default"])(base.InitialValues.devTags[PositiveIssueTagSix])) {
    initialValues.positive.userRows.push({
      columns: [base.InitialValues.devTags[PositiveIssueTagSix]]
    });
  }
  if (!(0, _isNil2["default"])(base.InitialValues.devTags[PositiveIssueTagSeven])) {
    initialValues.positive.userRows.push({
      columns: [base.InitialValues.devTags[PositiveIssueTagSeven]]
    });
  }
  if (!(0, _isNil2["default"])(base.InitialValues.devTags[PositiveIssueTagEight])) {
    initialValues.positive.userRows.push({
      columns: [base.InitialValues.devTags[PositiveIssueTagEight]]
    });
  }
  if (!(0, _isNil2["default"])(base.InitialValues.devTags[PositiveIssueTagNine])) {
    initialValues.positive.userRows.push({
      columns: [base.InitialValues.devTags[PositiveIssueTagNine]]
    });
  }
  if (!(0, _isNil2["default"])(base.InitialValues.devTags[PositiveIssueTagTen])) {
    initialValues.positive.userRows.push({
      columns: [base.InitialValues.devTags[PositiveIssueTagTen]]
    });
  }
  if (!(0, _isNil2["default"])(base.InitialValues.devTags[PositiveIssueTagEleven])) {
    initialValues.positive.userRows.push({
      columns: [base.InitialValues.devTags[PositiveIssueTagEleven]]
    });
  }
  if (!(0, _isNil2["default"])(base.InitialValues.devTags[PositiveIssueTagTwelve])) {
    initialValues.positive.userRows.push({
      columns: [base.InitialValues.devTags[PositiveIssueTagTwelve]]
    });
  }
  if (!(0, _isNil2["default"])(base.InitialValues.devTags[PositiveIssueTagThirteen])) {
    initialValues.positive.userRows.push({
      columns: [base.InitialValues.devTags[PositiveIssueTagThirteen]]
    });
  }
  if (!(0, _isNil2["default"])(base.InitialValues.devTags[PositiveIssueTagFourteen])) {
    initialValues.positive.userRows.push({
      columns: [base.InitialValues.devTags[PositiveIssueTagFourteen]]
    });
  }
  if (!(0, _isNil2["default"])(base.InitialValues.devTags[PositiveIssueTagFifteen])) {
    initialValues.positive.userRows.push({
      columns: [base.InitialValues.devTags[PositiveIssueTagFifteen]]
    });
  }
  return initialValues;
};